import moment from 'moment'
import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/Sales/goals'

export default {
  namespaced: true,
  state: {
    loading: false,
    rates: {
      data: [],
      grandTotals: {
        goals: 0,
        sales: 0,
        rates: 0,
      },
    },
    months: [],
    years: [],
    ratesParams: {
      month: moment().format('M'),
      year: moment().format('YYYY'),
    },
  },
  getters: {
    loading(state) {
      return state.loading
    },
    rates(state) {
      return state.rates
    },
    ratesParams(state) {
      return state.ratesParams
    },
    months(state) {
      return state.months
    },
    years(state) {
      return state.years
    },
  },
  mutations: {
    SET_LOADING(state, data) {
      state.loading = data
    },
    SET_RATES(state, data) {
      state.rates = data
    },
    SET_PARAMS(state, data) {
      state.months = data.months
      state.years = data.years
    },
    /* RESET MUTATIONS */
    RESET_RATES(state) {
      state.interviews = {
        data: [],
        grandTotals: {
          goals: 0,
          sales: 0,
          rates: 0,
        },
      }
    },
  },
  actions: {
    getRates({ commit }, params) {
      commit('SET_LOADING', true)
      commit('RESET_RATES')
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/rates`, data)
        .then(response => {
          commit('SET_RATES', response.data)
          commit('SET_LOADING', false)
        })
        .catch(error => console.error(error))
    },
    getParams({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/params`, data)
        .then(response => {
          commit('SET_PARAMS', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
